export default __webpack_public_path__ + "static/media/popup-img.d41debc8.png";